import { CalloutRoot, CalloutIcon, CalloutContent, CalloutTitle, CalloutDescription, CalloutActions } from './callout-primitives';

export const Callout = {
  get Root() {
    return CalloutRoot;
  },
  get Icon() {
    return CalloutIcon;
  },
  get Content() {
    return CalloutContent;
  },
  get Title() {
    return CalloutTitle;
  },
  get Description() {
    return CalloutDescription;
  },
  get Actions() {
    return CalloutActions;
  },
};
